import { SVGProps } from 'react';
import { ReactComponent } from 'icons/message2.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const Message2Icon = (props: Props) => {
  return <ReactComponent className="merc-icon-message2" {...props} />;
};
